<template>
  <TabView :activeIndex="tabIndex" @tab-change="($event) => tabIndex = $event.index">
    <TabPanel header="Активные события">
      <ActiveEvent scrollHeight="750px" checkFacilityId />
    </TabPanel>
    <TabPanel header="События">
      <ViewCustomData v-if="tabIndex === 1" entityName="event" entitySpec="data" serviceName="BaseService"
        :columns="EVENT_DATA_COLUMNS" :toolbarFilters="toolbarFilters" :rows="100" :dictionary="EVENT_DATA_DICTIONARY"
        sortField="event_date" :drawRow="rowClassEvent" scrollHeight="720px" :visibleButtons="visibleButtons">
      </ViewCustomData>
    </TabPanel>
    <TabPanel header="Уведомления">
      <ViewCustomData v-if="tabIndex === 2" entityName="command_log" entitySpec="data" serviceName="BaseService"
        :columns="COMMAND_LOG_COLUMNS" :toolbarFilters="toolbarFilters" :rows="100" sortField="command_date"
        :drawRow="rowClassLog" scrollHeight="720px" :visibleButtons="visibleButtons">
      </ViewCustomData>
    </TabPanel>
    <TabPanel header="Аудит квитирования">
      <ViewCustomData v-if="tabIndex === 3" entityName="event_confirm_sound" entitySpec="data" serviceName="BaseService"
        :columns="EVENT_CONFIRM_SOUND_COLUMNS" :toolbarFilters="toolbarFilters" :rows="100" scrollHeight="720px"
        :visibleButtons="visibleButtons" scheme="dbo">
      </ViewCustomData>
    </TabPanel>
  </TabView>
</template>

<script setup>
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import {
  getToolbarFilters, rowClassEvent, rowClassLog,
  EVENT_DATA_DICTIONARY, EVENT_DATA_COLUMNS, COMMAND_LOG_COLUMNS, EVENT_CONFIRM_SOUND_COLUMNS
} from './constants';
import ActiveEvent from './ActiveEvent.vue';

const route = useRoute(); 
const visibleButtons = {
  insert: false,
  edit: false,
  delete: false,
}
const tabIndex = ref(0);
const toolbarFilters = ref(getToolbarFilters(route.params));
</script>

<style scoped lang="scss">
::v-deep(.row-accessories-blue) {
  background-color: rgba(57, 26, 196, 1) !important;
}

::v-deep(.row-accessories-green) {
  background-color: #c0dcc0 !important;
}

::v-deep(.row-accessories-red) {
  background-color: #ff6c6c !important;
}

::v-deep(.row-accessories-yellow) {
  background-color: #fcfa98 !important;
}

::v-deep(.row-accessories-orange) {
  background-color: #f8d69c !important;
}

::v-deep(.row-accessories-red_ligt) {
  background-color: #f58484 !important;
}
</style>